module.exports = __webpack_public_path__ + "img/hn.c94622ad.svg";